import { IProblemDetails } from './client.generated.klantcontactService';

interface ErrorResult {
  error: string;
}
export class ClientHelper {
  static getStatusCode = (reason: unknown): number | null => {
    if ( (reason as ApiExceptionError)?.response) {
      return (reason as ApiExceptionError)?.response?.status ?? null;
    }
    return (reason as any)?.status ?? ((reason as any)?.statusCode ?? null);
  };

  static getErrorModel = <T>(reason: unknown): T | null => {
    if ( (reason as ApiExceptionError)?.response) {
      return ((reason as ApiExceptionError)?.response?.data as T) ?? null;
    }
    return (reason as any as T) ?? null;
  };

  static getErrorMessage = (reason: unknown): string => {
    let errorMessage: string | null = null;

    switch (ClientHelper.getStatusCode(reason)) {
      case null:
      case 400: {
        const result = ClientHelper.getErrorModel<IProblemDetails[]>(reason);

        if (result && result.length > 0) {
          errorMessage = result[0].title ?? null;
        }

        break;
      }
      case 404:
        errorMessage = ClientHelper.getErrorModel<IProblemDetails>(reason)?.title ?? null;
        break;
      case 500: {
        const model = ClientHelper.getErrorModel<IProblemDetails>(reason);

        if (model?.status === 504 || model?.status === 408) {
          errorMessage = "Door een timeout zijn er geen gegevens";
        } else {
          errorMessage = model?.title || ""
        }
        break;
      }
      default:
        break;
    }

    if (errorMessage) {
      return errorMessage;
    }

    return "Er is een storing";
  };
}

class ApiExceptionError extends Error {
  response?: ApiExceptionErrorReponse;
}

class ApiExceptionErrorReponse {
  status: number;
  data?: unknown;
}
